import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { SrxApi } from '../../api/SrxApi';

const useUpdateOrderReturn = () => {
    const { mutate: updateOrderReturn, isLoading } = useMutation(
        async (payload) => {
            const response = await SrxApi.post('/orderReturns/update-return', payload);
            return response?.data;
        },
        {
            onSuccess: (data) => {
                const message = data?.message ?? data?.data?.message ?? 'Order return updated successfully!';
                toast.success(message);
            },
            onError: (error) => {
                const errorMessage =
                    error?.response?.data?.message || error?.message || 'Failed to update order return';
                toast.error(errorMessage);
            },
        }
    );

    return { updateOrderReturn, isUpdateOrderReturnLoading: isLoading };
};

export default useUpdateOrderReturn;
